import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/applications/editor/src/app/error.tsx");
